module.exports = __webpack_public_path__ + "static/media/9.a10603b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/9.jpg
// module id = 72
// module chunks = 0